<template>
    <div v-if="isReady" class="background-inbox-budget-card" v-resize="onResize">
        <v-row no-gutters class="standard-row font-header-budget-tabs d-flex justify-space-between" align="center" style="font-weight: 700; padding: 21px 4.4% 0% 2.5%;">
            <v-col cols="11" sm="11" md="auto" lg="auto" class="mt">
                <v-slide-group show-arrows mandatory v-model="permissionTabs" color="black">
                    <v-select hide-details :items="dataHeaderTypeList" v-model="selectedTypeDataHeader" outlined append-icon="mdi-chevron-down" height="46" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" return-object class="font-theme select-unknown-inbox-record-cost mr-4" style="max-width: 150px;" @change="changeSearchHeader($event.value)">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 17px;">{{ data.item.text }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 17px;">ไม่พบข้อมูล</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-select>
                    <v-slide-item v-show="selectedTypeDataHeader.value === 'pr'" v-slot="{ active, toggle }" :value="permission" v-for="(permission, indexPermission) in myPermission" :key="`permission_${indexPermission}${permission}`">
                        <v-btn :input-value="active" active-class="select-header-budget-inbox-tabs" class="font-header-budget-tabs" @click="toggle" height="46" depressed rounded text>
                            {{ permission.inbox?.toUpperCase() }}
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
            <v-col cols="1" sm="1" v-if="windowSize.x < 980" class="d-flex justify-end"> <!--v-if="windowSize.x < 600 || false" -->
                <template>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list v-if="selectedTypeDataHeader.value == 'pr'" style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReportPR()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-list v-if="selectedTypeDataHeader.value == 'cs'" style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReportCS()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>  
                    </v-menu>
                </template>
            </v-col>
            <v-col v-else sm="auto" md="auto" lg="auto" class="d-flex justify-center">
                <v-btn rounded color="#0B68D6" v-if="selectedTypeDataHeader.value == 'pr' && true" @click="goToDownloadReportPR()" class="white--text text-center download-report-inbox-budget-btn" height="53" width="193" style="font-weight: 700; font-size: 15px;">
                    Download Report
                </v-btn>
                <v-btn rounded color="#0B68D6" v-if="selectedTypeDataHeader.value == 'cs' && true" @click="goToDownloadReportCS()" class="white--text text-center download-report-inbox-budget-btn" height="53" width="193" style="font-weight: 700; font-size: 15px;">
                    Download Report
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" align="center" style="font-weight: 700; padding: 20px 4.4% 0% 4.4%;">
            <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 15px;" class="ml-4 ml-sm-0">
                    ค้นหา
                </v-col>
                <v-col cols="" sm="" md="4" lg="4" class="ml-sm-8">
                    <v-text-field dense outlined hide-details color="black" background-color="white" height="42" class="font-theme search-text-field-inbox-budget" v-model="holdKeyword" @input="!holdKeyword? checkRowsAndPageBeforeSearch(holdKeyword): ''" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)">
                        <template v-slot:append v-if="windowSize.x < 600">
                            <v-btn icon style="margin-top: 3px">
                                <v-icon size="38">mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="windowSize.x > 600" sm="auto" md="auto" lg="auto" class="ml-5">
                    <v-btn rounded color="#0B68D6" class="white--text" height="42" width="125"  @click="checkRowsAndPageBeforeSearch(holdKeyword)" style="font-weight: 700; font-size: 15px; box-shadow: none;">
                        Search
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row font-theme pt-4 pt-sm-7" align="center">
                <v-col cols="12" sm="3" md="2" lg="1" style="font-size: 15px;" class="ml-4 ml-sm-0">
                    ประเภทเอกสาร
                </v-col>
                <v-col cols="12" sm="9" md="4" lg="4" class="ml-lg-0">
                    <v-autocomplete :items="allDocumentType[selectedTypeDataHeader.value]" hide-details outlined dense height="42" item-text="name" v-model="selectedDocType" append-icon="mdi-chevron-down" background-color="white" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="search-dropdown-inbox-budget" return-object @change="checkPageForGetTransaction()">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">{{ data.item.name }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-spacer v-if="windowSize.x > 960 && windowSize.x < 1264"></v-spacer>
                <v-col cols="12" sm="3" md="1" lg="1" style="font-size: 15px;" class="ml-4 ml-sm-0 ml-lg-16 mt-4 mt-sm-7 mt-md-0 pl-lg-10">
                    ช่วงเวลา
                </v-col>
                <v-col cols="12" sm="9" md="4" lg="4" class="ml-lg-0 mt-0 mt-sm-7 mt-md-0">
                    <v-menu offset-y v-model="dateMenu" min-width="auto" :close-on-content-click="false" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense hide-details clearable readonly v-on="on" color="black" :value="dateRangeShow" outlined background-color="white" height="42" @click:clear="dateRangeFilter = [], checkHeaderType()" class="font-theme search-text-field-inbox-budget clear-icon-date-budget-inbox"></v-text-field>
                        </template>
                        <v-date-picker color="#0B68D6" range no-title show-current locale="th" v-model="dateRangeFilter" @change="dateRangeFilter.length == 2? searchTransactionByDate() : ''" class="font-theme detail-date-picker-budget-inbox" :max="new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row font-theme pt-5 display-pc-only" align="center">
                <v-slide-group show-arrows mandatory v-model="documentDwfStatus">
                    <v-slide-item v-slot="{ active, toggle }" :value="docStatus.value" v-for="docStatus in allStatusDocumentTab[selectedTypeDataHeader.value]" :key="docStatus.value">
                        <v-btn :input-value="active" active-class="selected-status-budget-inbox-tab" class="document-status-budget-inbox-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline :color="docStatus.color" :content="countTransaction[docStatus.value]?.toString() || '0'" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                {{ docStatus.status }}
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-row>
            <v-row no-gutters class="standard-row pt-4 pt-sm-7 display-mobile-only" align="center">
                <v-col cols="12" style="font-size: 15px;" class="ml-4">
                    สถานะ
                </v-col>
                <v-col cols="12">
                    <v-select :items="allStatusDocumentTab[selectedTypeDataHeader.value]" v-model="documentDwfStatus" hide-details outlined dense height="42" item-text="status" item-value="value" append-icon="mdi-chevron-down" background-color="white" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="search-dropdown-inbox-budget">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">{{ data.item.status }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row mt-4 mb-7">
                <v-data-table :headers="allHeader[selectedTypeDataHeader.value]" range :items="myTransactions" fixed-header class="elevation-0 list-data-budget-inbox-table" style="width: 100%" :server-items-length="countTransaction[documentDwfStatus]" :options.sync="optionsTransaction" :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า' }" mobile-breakpoint="601">
                    <template v-slot:[`item.document_status_dwf`] = "{ item }">
                        <span v-if="item.document_status_dwf?.toLowerCase() === 'w'" style="color: #3B639F;">รออนุมัติผ่าน DWF</span>
                        <span v-else-if="item.document_status_dwf?.toLowerCase() === 'y'" style="color: #74CA5F;">ดำเนินการเสร็จสิ้น</span>
                        <span v-else-if="item.document_status_dwf?.toLowerCase() === 'r'" style="color: #D96353;">ปฎิเสธการอนุมัติ</span>
                    </template>
                    <template v-slot:[`item.po_status`] = "{ item }">
                        <span v-if="item.po_status?.toLowerCase() === 'w'" style="color: #3B639F;">รออนุมัติ</span>
                        <span v-else-if="item.po_status?.toLowerCase() === 'y'" style="color: #74CA5F;">ดำเนินการเสร็จสิ้น</span>
                        <span v-else-if="item.po_status?.toLowerCase() === 'r'" style="color: #D96353;">ปฎิเสธการอนุมัติ</span>
                        <span v-else-if="item.po_status?.toLowerCase() === 'บันทึก'" style="color: #BDBDBD;">บันทึก</span>
                    </template>
                    <template slot="no-data">
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:no-results>
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:footer.page-text="items">
                        {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                    </template>
                </v-data-table>
            </v-row>
        </v-row>
        <DownloadReportModal />
    </div>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import DownloadReportModal from '../components/DownloadReportModal.vue'
    export default {
        components: {
            DownloadReportModal
        },
        data: () => ({
            allHeader: {
                "pr" : [
                    { text: "หมวดตัดงบ", value: "cut_budget_string", align: "center", sortable: false },
                    { text: "เลขเอกสาร", value: "document_id", align: "center", sortable: false },
                    { text: "ชื่อ - นามสกุล", value: "sender", align: "center", sortable: false },
                    { text: "จำนวนเงิน", value: "total_price", align: "center", sortable: false },
                    { text: "รายละเอียด", value: "description", align: "center", sortable: false },
                    { text: "วันที่", value: "updated_at", align: "center", sortable: false },
                    { text: "DWF", value: "document_status_dwf", align: "center", sortable: false }
                ],
                "cs" : [
                    { text: "No", value: "document_id", align: "center", sortable: false },
                    { text: "SO", value: "so_number", align: "center", sortable: false },
                    { text: "CS", value: "cs_document_id", align: "center", sortable: false },
                    { text: "Job Status", value: "job_status", align: "center", sortable: false },
                    { text: "Group Service", value: "group_service", align: "center", sortable: false },
                    { text: "Service Name", value: "service_name", align: "center", sortable: false },
                    { text: "วันที่ทำรายการ", value: "updated_at", align: "center", sortable: false },
                    { text: "PO Status", value: "po_status", align: "center", sortable: false }
                ]
            },
            allStatusDocumentTab : {
                "pr" : [
                    { status: 'รออนุมัติผ่าน DWF', value: 'W', color: '#3B639F'},
                    { status: 'ดำเนินการเสร็จสิ้น', value: 'Y', color: '#74CA5F'},
                    { status: 'ปฎิเสธการอนุมัติ', value: 'R', color: '#D96353'}
                ],
                "cs" : [
                    { status: 'รออนุมัติ', value: 'W', color: '#3B639F'},
                    { status: 'ดำเนินการเสร็จสิ้น', value: 'Y', color: '#74CA5F'},
                    { status: 'ปฎิเสธการอนุมัติ', value: 'R', color: '#D96353'}
                ]
            },
            allDocumentType: {
                "pr" : [{ name : "ทั้งหมด", pr_id: "00",  _id  : "" }],
                "cs" : [
                    { name : "ทั้งหมด", value: '' },
                    { name : "Run PO", value: 'run_po' },
                    { name : "บันทึก", value: 'save_cs_to_po' }
                ]
            },
            dataHeaderTypeList: [
                { text: 'PR', value: "pr"},
                { text: 'CS', value: "cs"},
            ],
            isChangeDataHeaderType: false,
            selectedTypeDataHeader: { text: 'PR', value: "pr"},
            selectDocStatus: 'W',
            callApiPending: 0,
            optionsTransaction: { 
                "page": 1,
                "itemsPerPage": 20
            },
            selectedDocType: {
                "name" : "ทั้งหมด",
                "pr_id": "00",
                "_id"  : ""
            },
            keyword: '',
            isReady: false,
            dateMenu: false,
            holdKeyword: '',
            myPermission: [],
            isChangeTab: false,
            permissionTabs: {},
            myTransactions: [],
            dateRangeFilter: [],
            windowSize: { x: 0 },
            countTransaction: {},
            trigRowPerPage: false,
            documentDwfStatus: 'W'
        }),
        mounted () {
            this.onResize()
            this.getDoctypeList()
        },
        watch: {
            "optionsTransaction.page"(newValue) {
                if ((newValue != 1 || !this.isChangeTab) && !this.isChangeDataHeaderType) {
                    this.checkHeaderType()
                    this.trigRowPerPage = true
                }
            },
            "optionsTransaction.itemsPerPage"() {
                if (!this.trigRowPerPage && !this.isChangeDataHeaderType) {
                    this.optionsTransaction.page = 1
                    this.checkHeaderType()
                }
            },
            "permissionTabs"() {
                if (!this.isChangeDataHeaderType) {
                    this.checkPageForGetTransaction()
                }
            },
            "documentDwfStatus"() {
                if (!this.isChangeDataHeaderType) {
                    this.optionsTransaction.page = 1
                    this.checkHeaderType()
                    this.isChangeTab = true
                }
            },
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        computed: {
            dateRangeShow() {
                let formatDate = ''
                if (this.dateRangeFilter.length === 2) {
                    formatDate = this.dateRangeFilter.map(element => MainFunction.shortDate(element)).join('  —  ')
                } else {
                    formatDate = ''
                }
                return formatDate
            },
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            },
            raDetail() {
                return this.$store.state.raDetail
            },
            permissionInbox() {
                return this.$store.state.permissionInbox
            },
            setGetBudgetType () {
                return this.$store.state.budgetType
            }
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            async getDoctypeList() {
                this.callApiPending++
                this.allDocumentType['pr'] = [{ name : "ทั้งหมด", pr_id: "00",  _id  : "" }]
                try {
                    const { data } = await this.axios.get(`${this.$api_url}/document_type/api/v1/get_document_type?tax_id=${this.selectedBiz.tax_id}`)
                    if (data.status && data.data.length) {
                        this.allDocumentType['pr'] = [...this.allDocumentType['pr'], ...data.data]
                    }
                } catch (error) {
                    this.alert(`เกิดข้อผิดพลาด`, 'Fail', 'error')
                    console.log(error)
                } finally {
                    this.myPermission = []
                    if (this.permissionInbox.length) {
                        for (let i = 0; i < this.permissionInbox.length; i++) {
                            if (!['inbox', 'บัญชี'].includes(this.permissionInbox[i].inbox.toLowerCase())) {
                                if((this.selectedBiz.tax_id === '0107544000094' && this.permissionInbox[i].inbox.toLowerCase()) === 'report'){
                                    this.myPermission = [
                                        {
                                        inbox   : 'COST'          || '',
                                        dept_id : this.permissionInbox[i].dept_id.join('') || ''
                                        },
                                        {
                                        inbox   : 'RD'          || '',
                                        dept_id : this.permissionInbox[i].dept_id.join('') || ''
                                        },
                                        {
                                        inbox   : 'SGA'          || '',
                                        dept_id : this.permissionInbox[i].dept_id.join('') || ''
                                        }
                                    ]
                                    break
                                } else{
                                    this.myPermission.push({
                                        inbox   : this.permissionInbox[i].inbox            || '',
                                        dept_id : this.permissionInbox[i].dept_id.join('') || ''
                                    })
                                }
                            }
                            // jv save budget
                            if(this.$group_biz_tax_id.includes(this.selectedBiz.tax_id) && ['บัญชี', 'report'].includes(this.permissionInbox[i].inbox.toLowerCase())) {
                                this.myPermission = this.setGetBudgetType.map(e => {
                                    return {
                                        inbox: e.type.toUpperCase() || '',
                                        dept_id : this.permissionInbox[i].dept_id.join('') || ''
                                    }
                                })
                                break
                            }
                        }
                    }
                    this.callApiPending--
                    if (!this.callApiPending) {
                        this.isReady = true
                    }
                }
            },
            async getTransaction() {
                if (!this.myPermission.length) {
                    return this.alert('ไม่พบสิทธิ์การเข้าถึง', 'Warning', 'info')
                }
                try {
                    this.callApiPending++
                    const countTransactions = {
                        baseURL : this.$api_url,
                        url     : `/save_budget/api/v1/save_budget_count?tax_id=${this.selectedBiz.tax_id || null}&inbox=${this.permissionTabs?.inbox || ''}&dept_id=${this.raDetail.orgchart?.department?.map(e => e.orgchartId).join('') || null}&document_type_id=${this.selectedDocType._id || ''}&keyword=${this.keyword || ''}&start_date=${this.dateRangeFilter?.sort()[0] || ''}&end_date=${this.dateRangeFilter?.sort()[1] || ''}`,
                        method  : 'GET'
                    }
                    const searchTransactions = {
                        baseURL : this.$api_url,
                        url     : `/save_budget/api/v1/save_budget_search?tax_id=${this.selectedBiz.tax_id || null}&inbox=${this.permissionTabs?.inbox || ''}&dept_id=${this.raDetail.orgchart?.department?.map(e => e.orgchartId).join('') || null}&document_status=${this.documentDwfStatus || null}&document_type_id=${this.selectedDocType._id || ''}&keyword=${this.keyword || ''}&start_date=${this.dateRangeFilter?.sort()[0] || ''}&end_date=${this.dateRangeFilter?.sort()[1] || ''}&limit=${this.optionsTransaction.itemsPerPage || 20}&offset=${((this.optionsTransaction.page - 1) * this.optionsTransaction.itemsPerPage) || 0}`,
                        method  : 'GET'
                    }
                    const data = await Promise.all([ this.axios(countTransactions), this.axios(searchTransactions) ])
                    this.countTransaction = {
                        'Y' : data[0].data.data.approve  || 0,
                        'W' : data[0].data.data.process  || 0,
                        'R' : data[0].data.data.reject   || 0
                    }
                    this.myTransactions = []
                    if (data[1].data.data.length) {
                        for (let i = 0; i < data[1].data.data.length; i++) {
                            data[1].data.data[i].updated_at  = MainFunction.shortDate(data[1].data.data[i].updated_at)
                            data[1].data.data[i].total_price = MainFunction.addComma(data[1].data.data[i].total_price)
                            this.myTransactions.push(data[1].data.data[i])
                        }
                        $(".list-data-budget-inbox-table.v-data-table > .v-data-table__wrapper").scrollTop(0)
                        document.querySelector(".list-data-budget-inbox-table").classList.remove("cost-sheet-budget-inbox-table");
                    }
                } catch (error) {
                    this.myTransactions   = []
                    this.countTransaction = {
                        'Y': 0,
                        'W': 0,
                        'R': 0
                    }
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                    console.log(error)
                } finally {
                    this.callApiPending--
                    this.isChangeDataHeaderType = false;
                    this.isChangeTab = false
                    this.trigRowPerPage = false
                    if (!this.callApiPending) {
                        this.isReady = true
                    }
                }
            },
            checkRowsAndPageBeforeSearch(params) {
                if (this.keyword === params) {
                    return
                }
                this.keyword = params.trim()
                this.checkPageForGetTransaction()
            },
            searchTransactionByDate() {
                this.dateMenu = false
                this.dateRangeFilter = this.dateRangeFilter.sort()
                this.checkPageForGetTransaction()
            },
            checkPageForGetTransaction() {
                if (this.optionsTransaction.page === 1) {
                    this.checkHeaderType()
                } else {
                    this.optionsTransaction.page = 1
                }
            },
            goToDownloadReportPR(){
                const aboutReport = {
                    url        : '/report/api/v1/export_report_save_budget',
                    permission : this.permissionTabs.inbox,
                    from       : 'budget_inbox'
                }
                EventBus.$emit('openDownloadReportModal', aboutReport)
            },
            goToDownloadReportCS(){
                const aboutReport = {
                    url        : '/report/api/v1/export_report_cs_to_po_budgeting',
                    permission : 'CS',
                    from       : 'budget_cs_po'
                }
                EventBus.$emit('openDownloadReportModal', aboutReport)
            },
            checkHeaderType() {
                if (this.selectedTypeDataHeader.value === 'cs') {
                    this.getCStoPoTransaction()
                } else {
                    this.getTransaction()
                }
            },
            changeSearchHeader(event) {
                this.isChangeDataHeaderType = true;
                this.$nextTick(() => {
                    this.keyword = '';
                    this.holdKeyword = '';
                    this.myTransactions = [];
                    this.dateRangeFilter = [];
                    this.selectDocStatus = 'W';
                    this.permissionTabs = this.myPermission[0];
                    this.countTransaction = { 'Y': 0, 'W': 0, 'R': 0 };
                    this.selectedDocType = this.allDocumentType[event][0];
                    this.documentDwfStatus = this.allStatusDocumentTab[event][0].value;
                    this.checkHeaderType();
                });
            },
            async getCStoPoTransaction() {
                this.callApiPending++;
                const countTransactions = {
                    baseURL : this.$api_url,
                    url     : `/cs_to_po/api/v1/inbox_budgeting_count?keyword=${this.keyword || ''}&document_type=${this.selectedDocType.value || ''}&start_date=${this.dateRangeFilter?.sort()[0] || ''}&end_date=${this.dateRangeFilter?.sort()[1] || ''}`,
                    method  : 'GET'
                };
                const searchTransactions = {
                    baseURL : this.$api_url,
                    url     : `/cs_to_po/api/v1/inbox_budgeting_search?keyword=${this.keyword || ''}&document_type=${this.selectedDocType.value || ''}&start_date=${this.dateRangeFilter?.sort()[0] || ''}&end_date=${this.dateRangeFilter?.sort()[1] || ''}&limit=${this.optionsTransaction.itemsPerPage}&offset=${((this.optionsTransaction.page - 1) * this.optionsTransaction.itemsPerPage) || 0}&po_status=${this.documentDwfStatus || ''}`,
                    method  : 'GET'
                };
                try {
                    const data = await Promise.all([ this.axios(countTransactions), this.axios(searchTransactions) ]);
                    if (data[0].data.status) {
                        this.countTransaction = {
                            'Y' : data[0].data.data.approved || 0,
                            'W' : data[0].data.data.waiting || 0,
                            'R' : data[0].data.data.rejected || 0
                        };
                    }
                    if (data[1].data.status) {
                        this.myTransactions = data[1].data.data.map(e => {
                            return {
                                "document_id": e.document_id,
                                "so_number": e.so_number,
                                "cs_document_id": e.cs_document_id,
                                "job_status": e.job_status,
                                "group_service": e.group_service,
                                "service_name": e.service_name,
                                "updated_at": MainFunction.shortDate(e.updated_at),
                                "po_status": e.po_status,
                            }
                        });
                        $(".list-data-budget-inbox-table.v-data-table > .v-data-table__wrapper").scrollTop(0);
                        document.querySelector(".list-data-budget-inbox-table").classList.add("cost-sheet-budget-inbox-table");
                    }
                } catch (error) {
                    this.myTransactions = [];
                    this.countTransaction = { 'Y': 0, 'W': 0, 'R': 0 };
                    this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error');
                    console.log(error);
                } finally {
                    this.callApiPending--;
                    this.isChangeDataHeaderType = false;
                }
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            }
        }
    }
</script>

<style>
    .background-inbox-budget-card {
        background: #FFFFFF !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        border-radius: 23px;
        margin: 60px 2% 3.61% 2%;
    }

    .tab-detail {
        font-size: 36px;
        font-weight: 700;
        color: white !important;
    }

    .font-header-budget-tabs {
        font-family: 'Sarabun', sans-serif;
        font-size: calc(100% + 0.56vw) !important;
        font-weight: 700;
        letter-spacing: 1px;
        color: #8D8D8D !important;
    }

    .font-header-budget-tabs:before {
        background: transparent !important;
    }

    .document-status-budget-inbox-tab:before {
        background: transparent !important;
    }

    .select-header-budget-inbox-tabs {
        background: #73737380 !important;
        color: black !important;
    }

    .tab-detail-active {
        background: rgba(255, 254, 254, 0.5) !important;
        border-radius: 30px;
        opacity: 1;
        color: black !important;
    }

    .v-btn {
        text-transform: inherit;
    }

    .search-text-field-inbox-budget {
        border-radius: 30px !important;
    }

    .search-dropdown-inbox-budget {
        border-radius: 30px !important;
    }

    .search-dropdown-inbox-budget.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .search-text-field-inbox-budget.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .search-dropdown-inbox-budget .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon {
        margin-top: 8px;
    }

    .custom-badge-content {
        letter-spacing: 0 !important;
    }

    .search-dropdown-inbox-budget .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--clear {
        margin-top: 8px;
    }

    .custom-badge-content .v-badge__wrapper span {
        height: 27px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 8px;
        border-radius: 20px;
    }

    .custom-badge-content .v-badge__wrapper {
        margin-right: 0px;
        margin-left: 10px;
    }

    .selected-status-budget-inbox-tab {
        background-color: #D9D9D9;
    }

    .list-data-budget-inbox-table .v-data-table__wrapper table .v-data-table-header tr th {
        background-color: #F1F0F0;
        height: 56px;
        box-shadow: none;
    }

    .list-data-budget-inbox-table .v-data-table__wrapper table tbody tr td {
        font-size: 15px;
        border-bottom: none !important;
    }

    .cost-sheet-budget-inbox-table .v-data-table__wrapper table tbody tr td {
        font-size: 12px !important;
        border-bottom: none !important;
    }

    .list-data-budget-inbox-table {
        border-radius: 10px;
        overflow-y: auto;
    }

    .list-data-budget-inbox-table thead th:first-child {
        border-radius: 5px 0 0 0;
    }

    .list-data-budget-inbox-table thead th:last-child {
        border-radius: 0 5px 0 0;
    }

    .list-data-budget-inbox-table .v-data-table__wrapper table thead tr th {
        font-size: 15px;
    }

    .list-data-budget-inbox-table.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 259px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .list-data-budget-inbox-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .list-data-budget-inbox-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .list-data-budget-inbox-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F7F6F6;;
    }

    .list-data-budget-inbox-table > .v-data-table__wrapper > table > thead > tr > th {
        color: black !important;
    }

    .detail-date-picker-budget-inbox .theme--light.v-date-picker-table th {
        color: black !important;
        background-color: #E3E3E35E !important;
        font-size: 16px !important;
    }

    .detail-date-picker-budget-inbox .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .search-dropdown-inbox-budget.v-select.v-input--dense .v-select__selection--comma  {
        margin-left: 5px;
    }

    .search-dropdown-inbox-budget.v-text-field:not(.v-text-field--single-line) input {
        margin-left: 5px;
        line-height: 30px;
    }

    .search-text-field-inbox-budget .v-input__control .v-input__slot .v-text-field__slot input {
        margin-left: 5px;
        margin-right: 5px;
    }

    .search-text-field-inbox-budget .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .search-dropdown-inbox-budget .v-input__control .v-input__slot .v-select__slot .v-select__selections {
        line-height: 30px;
    }

    .download-report-inbox-budget-btn {
        border-radius: 30px;
        box-shadow: none;
    }

    .select-unknown-inbox-record-cost .v-input__control .v-input__slot .v-select__slot .v-select__selections {
        line-height: 30px;
        font-weight: 500;
        font-size: 20px;
    }

    .select-unknown-inbox-record-cost .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
        margin-top: 11px;
    }

    .select-unknown-inbox-record-cost .v-input__control .v-input__slot {
        min-height: 46px;
    }

    .select-unknown-inbox-record-cost .v-input__control .v-input__slot {
        border-radius: 10px;
        border: 1px solid #000000;
    }

    .clear-icon-date-budget-inbox .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--clear {
        margin-top: 8px;
    }

    @media only screen and (max-width: 600px) {

        .list-data-budget-inbox-table .v-data-table__wrapper table tbody tr td:last-child {
            border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
        }

        .list-data-budget-inbox-table .v-data-table__wrapper table tbody tr:last-child td {
            border-bottom: none !important;
        }

        .list-data-budget-inbox-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td:last-child {
            border-bottom: none !important;
        }

        .list-data-budget-inbox-table .v-data-table__empty-wrapper {
            display: flex;
            justify-content: center;
        }
    }
</style>